<div class="nav_overlay" *ngIf="navService.isMobileMenuOpen && authService.isAuthenticated" (click)="navService.closeMobileMenu()"></div>
<div class="nav_container" [class.nav_container--mobile-open]="navService.isMobileMenuOpen" *ngIf="authService.isAuthenticated && authService.credentials?.primeiroAcesso === 'N';">
  <app-navbar></app-navbar>
</div>
<div class="router_container" [ngClass]="{'router_container--autenticado': authService.isAuthenticated}">
  <app-header *ngIf="authService.isAuthenticated && authService.credentials?.primeiroAcesso === 'N';"></app-header>
  <router-outlet class="router_container__outlet"></router-outlet>
</div>